module.exports = __webpack_public_path__ + "img/Vendor.b865c0d1.svg";